<div class="modal open" *ngIf="show" (click)="onBackdrop($event)">
  <div class="modalcard" [class.wide]="wide" cdkTrapFocus>
    <span class="x" (click)="emitClose()">&times;</span>
    <h4 *ngIf="title">{{ title }}</h4>
    <div class="modal-sub muted fz12" *ngIf="subtitle">{{ subtitle }}</div>
    <div class="modal-body">
      <ng-content></ng-content>
    </div>
    <div class="modal-foot">
      <ng-content select="[modal-footer]"></ng-content>
    </div>
  </div>
</div>
